import { useSelectedFieldStore } from '../stores/selectedFieldStore';

export const useSelectedField = () => {
  const selectedField = useSelectedFieldStore((state) => state.selectedField);
  const setSelectedField = useSelectedFieldStore(
    (state) => state.setSelectedField
  );
  const clearSelectedField = useSelectedFieldStore(
    (state) => state.clearSelectedField
  );
  const getSelectedField = useSelectedFieldStore(
    (state) => state.getSelectedField
  );
  const isSelectedFieldLoaded = useSelectedFieldStore((state) =>
    state.isSelectedFieldLoaded()
  );

  return {
    selectedField,
    isLoaded: isSelectedFieldLoaded,
    setSelectedField,
    clearSelectedField,
    getSelectedField,
  };
};
